import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ReactComponent as OccasiaLogoIcon } from '../../components/icons/occasia-logo-icon.svg';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyEmailToken } = useAuth();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [errorMessage, setErrorMessage] = useState('');
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMessage('No verification token found. Please check your email link.');
      return;
    }

    (async () => {
      try {
        await verifyEmailToken(token);
        setStatus('success');
      } catch (err) {
        setStatus('error');
        setErrorMessage(err.message || 'Invalid or expired verification link.');
      }
    })();
  }, [searchParams, verifyEmailToken]);

  const handleContinue = () => {
    navigate('/');
  };

  return (
    <div className="verify-email-page">
      <div className="verify-email-container">
        <Link to="/" className="verify-email-logo">
          <OccasiaLogoIcon className="verify-email-logo-icon" />
        </Link>

        <div className="verify-email-card">
          {status === 'verifying' && (
            <>
              <div className="verify-email-spinner" />
              <h1 className="verify-email-title">Verifying your email</h1>
              <p className="verify-email-text">Please wait while we confirm your account...</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="verify-email-icon verify-email-icon--success">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="24" fill="#E6F4ED" />
                  <path d="M16 24L22 30L32 18" stroke="#046242" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h1 className="verify-email-title">Email verified!</h1>
              <p className="verify-email-text">
                Your account is now active. You can log in and start exploring.
              </p>
              <button
                type="button"
                className="verify-email-btn"
                onClick={handleContinue}
              >
                Continue to Occasia
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="verify-email-icon verify-email-icon--error">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="24" fill="#FEF2F2" />
                  <path d="M18 18L30 30M30 18L18 30" stroke="#EF4444" strokeWidth="3" strokeLinecap="round" />
                </svg>
              </div>
              <h1 className="verify-email-title">Verification failed</h1>
              <p className="verify-email-text">{errorMessage}</p>
              <Link to="/" className="verify-email-btn">
                Go to home page
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
